
'use strict';
import React from 'react';
import {
  Platform,
  Alert,
} from 'react-native';
import YPDToast from '@mi/duplo-toast';
import CommonBridge from 'common/CommonBridge';
import ModelConfrim from 'tmpl/common/ModelConfrim';

export default class Toast {
  static show (msg, type) {
    if (typeof msg !== 'string') {
      console.log('Toast:', msg);
      return;
    }
    if (Platform.OS == 'web') {
      this.showMessage(msg);
      return;
    }
    YPDToast.makeToast(msg, type);
  }

  static showWrapedMsg (msg) {
    Toast.show(` ${msg}`);
  }

  /**
   * 通用对话框
   * @param params: {title, content, cancelBtn, okBtn, callback}
   */
  static confirm (params, app) {
    let { title, content, cancelBtn, okBtn, callback } = params;
    title = title || '提 示';
    content = content || '您确定此操作？';
    cancelBtn = cancelBtn || '取消';
    okBtn = okBtn || '确定';

    if (CommonBridge.isWeb()) {
      if (CommonBridge.isSafari()) {
        app.showPopModal(() => {
          return <ModelConfrim app={app} {...params} />;
        });
        return;
      }
      // 有些浏览器 同步会触发2次confirm 用settimeout解决
      setTimeout(() => {
        if (confirm(content)) {
          callback && callback();
        }
      }, 0);
    } else {
      Alert.alert(
        title,
        content,
        [
          {
            text: cancelBtn,
            onPress: () => {
            },
          },
          {
            text: okBtn,
            onPress: () => {
              callback && callback();
            },
          },
        ]
      );
    }
  }

  /**
   * OK对话框
   * @param params: {title, content, okBtn, callback}
   */
  static singleConfirm (params) {
    let { title, content, okBtn, callback } = params;
    title = title || '提 示';
    content = content || '';
    okBtn = okBtn || '确定';

    if (CommonBridge.isWeb()) {
      if (alert(content)) {
        callback && callback();
      }
    } else {
      Alert.alert(
        title,
        content,
        [
          {
            text: okBtn,
            onPress: () => {
              callback && callback();
            },
          },
        ]
      );
    }
  }

  static setShowFunction (func) {
    this.func = func;
  }

  static showMessage (message) {
    this.func && this.func(message);
  }
}
